<template>
  <div class="flightDetailMainContainer" id="flightDetailMainContainer" >
    <div
      id="flightDetailMap"
      style="width: 100%; height: 100%"
      ref="flightDetailMap"
    ></div>
    <div id="flightDetailMapBg" class="flightDetailMapBg"></div>
    <div id="overlay" class="overlay" v-show="showFlightFeatureOverlay">
      <div class="header">{{ taskPlan.uasTypeName }}</div>
      <div class="main">
        <div class="row">
          <label class="title">编号</label><label>:</label>
          <label class="content">{{ taskPlan.uasSerialId }}</label>
        </div>
        <div class="row">
          <label class="title">Lon</label><label>:</label>
          <label class="content">{{ lastPoint.lon }}°</label>
        </div>
        <div class="row">
          <label class="title">Lat</label><label>:</label>
          <label class="content">{{ lastPoint.lat }}°</label>
        </div>
        <div class="row">
          <label class="title">Alt</label><label>:</label>
          <label class="content">{{ lastPoint.alt }}m</label>
        </div>
      </div>
    </div>

    <div class="backBtn" @click="back">
      <img src="../../../assets/img/home/flightDetail/back.png" />
      <label>返回上一页</label>
    </div>

    <!-- 地图模式调整 -->
    <!-- <MapStyle @changeMapStyle="changeMapStyle"></MapStyle> -->
    <FlightDetailVedio v-show="!isHistory" :taskPlan="taskPlan"></FlightDetailVedio>
    <FlightDetailAssessment
      v-show="isHistory"
      @showAirspace="showAirspace"
    ></FlightDetailAssessment>
    <FlightDetailWeather
      v-show="weatherContainerShow"
      @setBgTransparency="setBgTransparency"
    ></FlightDetailWeather>
    <FlightDetailRealTime
      style="border: 1px solid red"
      :isHistory="isHistory"
      :playOrPause="playOrPause"
      :replaySpeed="replaySpeed"
      :taskPlan="taskPlan"
      :currentPoint="lastPoint"
      @pauseOrPlay="pauseOrPlay"
      @changeSpeed="changeSpeed"
      @endFly="endFly"
      v-show="realTimeContainerShow"
    ></FlightDetailRealTime>
  </div>
</template>

<script type="text/javascript">
import MapStyle from "../../mapContent/MapStyle";
import FlightDetailVedio from "./flightDetailVedio";
import FlightDetailWeather from "./flightDetailWeather";
import FlightDetailRealTime from "./flightDetailRealTime";
import FlightDetailAssessment from "./flightDetailAssessment";

import { initMap, changeMapStyle } from "../../../assets/js/map/OlMapUtil";
import * as olProj from "ol/proj";
import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Overlay from "ol/Overlay";
import { Fill, Stroke, Icon, Style } from "ol/style";

import airspaceStyle from "../../../assets/js/map/airspaceStyle";
import { getPolygonCirclePoints } from "../../../assets/js/lonLatRadiusUtil.js";
import { wgs84ToGcj02, gcj02ToWgs84 } from "../../../assets/js/map/ConverseLngAndLa";

import uav from "../../../assets/img/home/flightDetail/uav.png";
import startPointer from "../../../assets/img/home/flightDetail/startPointer.png";
import endPointer from "../../../assets/img/home/flightDetail/endPointer.png";

export default {
  name: "flightDetailMain",
  data() {
    return {
      initHistory: false, //历史是否初始化完成
      isHistory: false, //是否是历史详情
      flightDetailMap: null,
      vectorLayer: null, //飞机Feature层级
      vectorSource: null,
      flightFeature: null,
      showFlightFeatureOverlay: false, //是否显示飞机标牌
      polyLine: null, //飞机航迹
      planPolyLine: null, //飞机航迹
      featureZIndex: 0, //feature显示ZIndex
      polyLinePoints: [], //飞机航迹点
      planPolylinePoints: [], //飞机计划航点
      center: [104.06, 30.67],
      mapType: "hybrid", //地图类型([normal:街道图;hybrid:卫星图])
      // vedioContainerShow: true, //视频弹窗
      weatherContainerShow: true, //天气弹窗
      realTimeContainerShow: true, //飞机实时信息弹窗
      // flightDetailAssessmentShow: true,
      bgTransparency: 15, //地图暗度
      taskPlan: {}, //计划信息
      isPlay: false, //当前是否正在播放
      replaySpeed: 1, //轨迹回放倍数
      playOrPause: false, //暂停或播放轨迹
      replayTimer: null, //当前回放的定时器
      queryRealTrackTimer: null, //实时查询点前航迹的定时器
      replayTrackPoints: [], //需要回放的点列表
      currentPointIndex: 0, //当前正在回放的点的位置
      lastPoint: { heading: 180, roll: 0, pitch: 0 }, //最后一个点信息
      uasSerialId: "3333333", //模拟的飞机uas_serial_id
      requestCounter: 0, //请求计数
      currentShowCounter: 0, //当前显示的点的计数
    };
  },
  methods: {
    init(id) {
      this.doEndFly(); //结束飞行
      this.cleanData(); //清除原先的飞机数据
      this.doInit(id); //请求数据并显示
    },
    doInit(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          const newData = this.resetTaskPlan(oData.data);
          const taskPlan = (this.$data.taskPlan = newData);
          this.initPlanPolyline(taskPlan);
          this.showStartEndPoint(taskPlan.startPoint, taskPlan.endPoint);
          //历史航迹查询
          if (70 <= taskPlan.flight_status) {
            this.$data.isHistory = true;
            this.queryHistoryTracks();
          } else {
            //查询实时航迹
            this.$data.isHistory = false;
            this.$data.uasSerialId = this.$data.taskPlan.uasSerialId;
            this.queryRealTracks(this.$data.requestCounter++);
            this.$data.queryRealTrackTimer = setInterval(() => {
              this.queryRealTracks(this.$data.requestCounter++);
            }, 3000);
          }
          this.$forceUpdate();
        } else if (oData.code != 401) {
        }
      });
    }, //初始化计划航线
    initPlanPolyline(taskPlan) {
      if (taskPlan.starstaypoint) {
        const starstaypoint = taskPlan.starstaypoint;
        if (starstaypoint.longitude && starstaypoint.latitude) {
          taskPlan.startPoint = this.toMercatorPoint(
            starstaypoint.longitude,
            starstaypoint.latitude
          );
        }
      }
      if (taskPlan.endstaypoint) {
        const endstaypoint = taskPlan.endstaypoint;
        if (endstaypoint.longitude && endstaypoint.latitude) {
          taskPlan.endPoint = this.toMercatorPoint(
            endstaypoint.longitude,
            endstaypoint.latitude
          );
        }
      }
      const planPolyline = (this.$data.planPolylinePoints = [taskPlan.startPoint]);
      try {
        if (!this.isEmptyStr(val.task_coordinate_waypoints)) {
          const points = val.task_coordinate_waypoints.split(";");
          for (let index = 0; index < points.length; index++) {
            try {
              const element = points[index];
              const arr = element.split(",");
              planPolyline.push(this.toMercatorPoint(arr[1], arr[2]));
            } catch (error) {}
          }
        }
      } catch (error) {}
      planPolyline.push(taskPlan.endPoint);
      this.showPlanPolyline();
    },
    queryHistoryTracks() {
      this.getRequest(
        "/uav-monitor-server/fly-status/history?flightId=" + this.$data.taskPlan.id
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          const replayTrackPoints = (this.$data.replayTrackPoints = this.resetHistoryTracks(
            oData.data
          ));
          if (!this.isEmptyArray(replayTrackPoints)) {
            this.showFlightFeature([replayTrackPoints[0].lon, replayTrackPoints[0].lat]);
            this.showHistoryTracks(); //显示历史飞行航迹
            this.doSetLastPoint(replayTrackPoints[0]);
          }
          this.$data.initHistory = true;
        } else if (oData.code != 401) {
        }
      });
    }, //显示历史航迹
    showHistoryTracks() {
      const replayTrackPoints = this.$data.replayTrackPoints;
      if (!this.isEmptyArray(replayTrackPoints)) {
        const polyLinePoints = (this.$data.polyLinePoints = []);
        for (let index = 0; index < replayTrackPoints.length; index++) {
          try {
            const element = replayTrackPoints[index];
            polyLinePoints.push(this.toMercatorPoint(element.lon, element.lat));
          } catch (error) {}
        }
        this.showPolyline();
      }
    },
    resetHistoryTracks(tracks) {
      if (this.isEmptyArray(tracks)) {
        return [];
      }
      const replayTrackPoints = [];
      for (let index = 0; index < tracks.length; index++) {
        try {
          const element = tracks[index];
          if (!this.isEmptyStr(element.message)) {
            replayTrackPoints.push(JSON.parse(element.message));
          }
        } catch (error) {}
      }
      return replayTrackPoints;
    },
    queryRealTracks(counter) {
      this.getRequest(
        "/uav-monitor-server/fly-status/real-time?uavNo=" + this.$data.uasSerialId
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          //如果显示计数小于请求计数,则显示航迹数据
          if (this.$data.currentShowCounter <= counter) {
            this.$data.currentShowCounter = counter;
            this.setLastPoint(oData.data);
            this.resetTracks(oData.data);
            this.showRealTrack(oData.data);
          }
        } else if (oData.code != 401) {
        }
      });
    },
    setLastPoint(tracks) {
      if (this.isEmptyArray(tracks)) {
        return;
      }
      this.doSetLastPoint(tracks[tracks.length - 1]);
    },
    doSetLastPoint(point) {
      const lastPoint = { ...point };
      lastPoint.lon = lastPoint.lon.toFixed(6);
      lastPoint.lat = lastPoint.lat.toFixed(6);
      lastPoint.alt0 = lastPoint.alt.toFixed(0);
      lastPoint.alt = lastPoint.alt.toFixed(2);
      lastPoint.pitch = lastPoint.pitch.toFixed(2);
      lastPoint.roll = lastPoint.roll.toFixed(2);
      lastPoint.heading = lastPoint.yaw.toFixed(2);
      lastPoint.groundSpeed = lastPoint.groundSpeed.toFixed(2);
      lastPoint.trueAirspeed = lastPoint.trueAirspeed.toFixed(2);
      lastPoint.windSpeed = lastPoint.windSpeed.toFixed(2);
      lastPoint.trueAirspeedM = (lastPoint.trueAirspeed / 3.6).toFixed(1);
      lastPoint.groundAlt = lastPoint.groundAlt.toFixed(2);
      lastPoint.remainingDis = (lastPoint.remainingDis / 1000).toFixed(2);
      lastPoint.remainingOil = lastPoint.remainingOil.toFixed(2);
      lastPoint.temperature = lastPoint.temperature.toFixed(2);
      lastPoint.remainingTime = lastPoint.remainingTime.toFixed(2);
      lastPoint.motStatusName = lastPoint.motStatus == 0 ? "正常" : "故障";
      lastPoint.navStatusName = lastPoint.navStatus == 0 ? "正常" : "故障";
      lastPoint.comStatusName = lastPoint.comStatus == 0 ? "正常" : "故障";
      this.$data.lastPoint = lastPoint;
    },
    showRealTrack(tracks) {
      if (this.isEmptyArray(tracks)) {
        return;
      }
      const polyLinePoints = this.$data.polyLinePoints;

      let flightFeature = this.$data.flightFeature;
      const vectorSource = this.$data.vectorSource;
      const mercatorPoint = polyLinePoints[polyLinePoints.length - 1];

      let flag = true;
      //如果飞机存在,先移除
      if (flightFeature) {
        flag = false;
        vectorSource.removeFeature(flightFeature);
      }
      flightFeature = this.$data.flightFeature = new Feature({
        id: "100000",
        geometry: new Point(mercatorPoint),
      }); //设置样式
      flightFeature.setStyle(this.getFlightStyle());
      vectorSource.addFeature(flightFeature);
      try {
        this.showFlightOverlay(mercatorPoint);
      } catch (error) {
        if (flag) {
          this.$nextTick(this.showFlightOverlay(mercatorPoint));
        }
      }
      this.showPolyline();
    },
    resetTaskPlan(data) {
      let newData = null;
      if (data) {
        if (data.flight) {
          newData = data.flight;
        }
        //拷贝除flight属性之外的其他属性到对象上
        for (const key in data) {
          const element = data[key];
          if ("flight" !== key) {
            newData[key] = element;
          }
        }

        if (data.uav) {
          newData.uasSerialId = data.uav.uas_serial_id;
          if (data.uav.uavmodel) {
            newData.uasTypeName = data.uav.uavmodel.name;
          }
        }

        if (data.airlink) {
          newData.airLinkName = data.airlink.name;
        }
      }
      return newData;
    }, //清除原先的飞机数据
    cleanData() {
      this.$data.initHistory = false;
      this.$data.flightFeature = null;
      this.$data.showFlightFeatureOverlay = false;
      this.$data.polyLine = null;
      this.$data.polyLinePoints = [];
      this.$data.taskPlan = {};
      this.$data.replayTrackPoints = [];
      this.$data.currentPointIndex = 0;
      this.$data.vectorSource.clear(); //清空图标
    },
    /* 空域相关 */
    //显示空域
    showAirspace(data) {
      this.defaultShowAirspace(this.$data.flightDetailMap, data);
    },
    /* 空域相关 */
    //初始化地图相关信息
    initMapInfo() {
      this.$data.flightDetailMap = initMap(
        "flightDetailMap",
        this.center,
        this.mapType,
        null
      );
      this.$data.vectorSource = new VectorSource({
        wrapX: false,
      });
      this.$data.vectorLayer = new VectorLayer({
        source: this.$data.vectorSource,
        zIndex: 1500,
      });
      this.$data.flightDetailMap.addLayer(this.$data.vectorLayer);
    },
    //Google坐标转换为墨卡托坐标
    toMercatorPoint(lng, lat) {
      let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理
      return olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标
    },
    //修改地图显示样式
    changeMapStyle: function (mapType) {
      this.mapType = mapType;
      changeMapStyle(mapType, this.flightDetailMainContainer);
    }, //设置地图暗度
    setBgTransparency(num) {
      this.$data.bgTransparency = 100 - num;
      const flightDetailMapBg = document.getElementById("flightDetailMapBg");
      flightDetailMapBg.style.backgroundColor =
        "rgba(0,0,0," + this.$data.bgTransparency / 100 + ")";
    }, //显示测试飞机
    showFlightFeature(point) {
      let flightFeature = this.$data.flightFeature;
      const vectorSource = this.$data.vectorSource;
      const mercatorPoint = this.toMercatorPoint(point[0], point[1]);

      let flag = true;
      //如果飞机存在,先移除
      if (flightFeature) {
        flag = false;
        vectorSource.removeFeature(flightFeature);
      }
      flightFeature = this.$data.flightFeature = new Feature({
        id: "100000",
        geometry: new Point(mercatorPoint),
      }); //设置样式
      flightFeature.setStyle(this.getFlightStyle());
      vectorSource.addFeature(flightFeature);
      try {
        this.showFlightOverlay(mercatorPoint);
      } catch (error) {
        if (flag) {
          this.$nextTick(this.showFlightOverlay(mercatorPoint));
        }
      }
    },
    resetTracks(tracks) {
      if (this.isEmptyArray(tracks)) {
        return;
      }
      const polyLinePoints = (this.$data.polyLinePoints = []);
      for (let index = 0; index < tracks.length; index++) {
        const element = tracks[index];
        polyLinePoints.push(this.toMercatorPoint(element.lon, element.lat));
      }
    },
    //飞机样式
    getFlightStyle() {
      return new Style({
        image: new Icon({
          anchor: [0.5, 0.5],
          src: uav,
          crossOrigin: "",
        }),
        zIndex: 1000,
      });
    }, //设置飞机Overlay信息
    showFlightOverlay(mercatorPoint) {
      let overlay = this.$data.flightDetailMap.getOverlayById("flightOverlay");
      if (!overlay) {
        overlay = new Overlay({
          id: "flightOverlay",
          element: document.getElementById("overlay"),
          offset: [24, 0],
          position: mercatorPoint,
          positioning: "top-left",
          autoPan: false, // 定义弹出窗口在边缘点击时候可能不完整 设置自动平移效果
          stopEvent: false,
        });
        this.$data.flightDetailMap.addOverlay(overlay);
      }
      overlay.setPosition(mercatorPoint);
      this.$data.showFlightFeatureOverlay = true; //显示覆盖物
    }, //显示起点和终点
    showStartEndPoint(start, end) {
      const vectorSource = this.$data.vectorSource;
      const feature0 = new Feature({ id: "0", geometry: new Point(start) });
      const feature1 = new Feature({ id: "1", geometry: new Point(end) });
      //设置样式
      feature0.setStyle(
        new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: startPointer,
            crossOrigin: "",
          }),
          zIndex: 100,
        })
      );
      feature1.setStyle(
        new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: endPointer,
            crossOrigin: "",
          }),
          zIndex: 100,
        })
      );
      vectorSource.addFeature(feature0);
      vectorSource.addFeature(feature1);
    }, //显示计划航迹
    showPlanPolyline() {
      this.doShowPolyline("planPolyline", "#FFFFFF", 40);
    }, //显示航迹
    showPolyline() {
      this.doShowPolyline("polyLine", "#FFA63E", 50);
    },
    doShowPolyline(polyLineName, color, zIndex) {
      let polyLine = this.$data[polyLineName];
      if (!polyLine) {
        polyLine = this.$data[polyLineName] = new LineString([]);
        const feature = new Feature({ geometry: polyLine });
        feature.setStyle(
          new Style({
            stroke: new Stroke({
              color: color,
              width: 2,
            }),
            zIndex: zIndex,
          })
        );
        this.$data.vectorSource.addFeature(feature);
      }
      polyLine.setCoordinates(this.$data[polyLineName + "Points"]);
    },
    //开始飞行或继续飞行
    startPlay() {
      const replayTrackPoints = this.$data.replayTrackPoints;
      const currentPointIndex = this.$data.currentPointIndex;
      //设置飞机图标位置
      const showPoint = replayTrackPoints[currentPointIndex];
      this.showFlightFeature([showPoint.lon, showPoint.lat]);
      this.doSetLastPoint(showPoint);
      if (currentPointIndex < replayTrackPoints.length - 1) {
        this.$data.currentPointIndex++;
        const nextPoint = replayTrackPoints[currentPointIndex + 1];
        const time = this.getNextPointTime(showPoint, nextPoint); //获取下次显示的时间
        //计算下次到的时间,开启定时
        this.$data.replayTimer = setTimeout(this.startPlay, time);
      } else {
        this.doEndFly(); //结束飞行
      }
    }, //获取下次显示的时间
    getNextPointTime(showPoint, nextPoint) {
      let time =
        this.$moment(nextPoint.time)._d.getTime() -
        this.$moment(showPoint.time)._d.getTime();
      return Math.ceil(time / this.$data.replaySpeed / 100);
    },
    endFly() {
      this.doEndFly();
      const replayTrackPoints = this.$data.replayTrackPoints;
      if (!this.isEmptyArray(replayTrackPoints)) {
        this.showFlightFeature([replayTrackPoints[0].lon, replayTrackPoints[0].lat]);
        this.doSetLastPoint(replayTrackPoints[0]);
      }
    },
    //结束飞行
    doEndFly() {
      if (this.$data.replayTimer) {
        clearTimeout(this.$data.replayTimer); //清空定时任务
      }
      if (this.$data.queryRealTrackTimer) {
        clearInterval(this.$data.queryRealTrackTimer); //清空定时任务
      }
      this.$data.polyLinePoints = []; //设置航迹点为空
      this.$data.currentPointIndex = 0;
      this.$data.isPlay = false; //设置状态为未播放
      this.$data.playOrPause = false;
    }, //播放或暂停航迹回放
    pauseOrPlay() {
      //如果是历史并且初始化未完成并且为开始播放
      if (this.$data.isHistory && !this.$data.initHistory && this.$data.playOrPause) {
        this.$message({
          message: "正在查询历史航迹,请稍后",
          duration: 1000,
          customClass: "message-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {},
        });
      }
      const playOrPause = (this.$data.playOrPause = !this.$data.playOrPause);
      if (!playOrPause) {
        if (this.$data.replayTimer) {
          clearTimeout(this.$data.replayTimer); //清空定时任务
          this.$data.currentPointIndex--; //暂停时将当前需要显示的点减1
        }
      } else {
        this.$data.isPlay = true;
        //继续播放或开始播放
        this.startPlay();
      }
    },
    changeSpeed(speed) {
      this.$data.replaySpeed = speed;
    },
    back() {
      this.$emit("showFlightDetail", { show: false });
    },
  },
  mounted() {
    this.initMapInfo();
    this.setBgTransparency(85);
  },
  watch: {},
  computed: {},
  components: {
    MapStyle,
    FlightDetailVedio,
    FlightDetailWeather,
    FlightDetailRealTime,
    FlightDetailAssessment,
  },
  beforeDestroy() {
    this.doEndFly();
    if (this.$data.flightDetailMap) {
      this.$data.flightDetailMap.dispose();
    }
  },
};
</script>

<style scoped>
@import "../../../assets/css/home/flightDetail/flightDetailMain.css";
</style>

<style>
/*隐藏ol的一些自带元素*/
#flightDetailMainContainer .ol-attribution {
  display: none;
}
#flightDetailMainContainer .ol-zoom {
  top: unset;
  left: unset;
  bottom: 7.5em;
  right: 0.5em;
  background: transparent;
  display: none;
}
#flightDetailMainContainer .ol-control button {
  width: 24px;
  height: 24px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
#flightDetailMainContainer .ol-control button:hover,
#flightDetailMainContainer .ol-control button:focus {
  background-color: #0083fd;
}
#flightDetailMainContainer .ol-zoom .ol-zoom-out {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/flightDetail/flightDetailMain.vue